const TRAILING_HASHTAGS_RE = /(?:\s*#[\p{L}\p{N}_]+)+\s*$/u;
export function stripDuplicateTrailingHashtags(caption, hashtags) {
    const text = caption ?? '';
    if (!hashtags || hashtags.length === 0)
        return text;
    return text.replace(TRAILING_HASHTAGS_RE, '').trimEnd();
}
//# sourceMappingURL=hashtag-utils.js.map